var exports = {
  "i": "xaf9ae18d--6a0ac3--wrapper",
};

module.exports = exports;
